import React, { useContext, useEffect, useState } from 'react';
import ChatListItem from '../ChatListItem/ChatListItem';
import MessageContext from '../../../../context/MessageContext';



import styles from './ChatHistory.module.scss'

interface ChatHistoryProps {
  handleOpenMessage?: any;
}

export default function ChatHistory({ handleOpenMessage }: ChatHistoryProps) {
  const { chatLogs }: any = useContext(MessageContext);

  return (
    <div className={styles.chatHistory}>
      <header className={styles.header}>
        <h3>Inbox</h3>
        <button className="btn btn-flat pa-0">
          <span className="icon-edit text-2c text-gray-50"></span>
        </button>
      </header>

      <section className={styles.chatList}>
        {chatLogs.map((chatLog: any) => (
          <div key={chatLog.userName} onClick={() => handleOpenMessage(true)}>
            <ChatListItem chatLog={chatLog} />
          </div>
        ))}
      </section>
    </div>
  );
}
